module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/donate-149.vue");


//////////////////
// WEBPACK FOOTER
// ./en/contribution/donate.md
// module id = 562
// module chunks = 441